<template>
  <SfTableRowCollapsibleItem
    :ignored-columns="ignoredColumns"
    :row-data="{ ...rowData, subsidiaryName: '' }"
    :variant="tableVariants.FLAT"
  >
    <template #cell-display="{ index }">
      <div
        v-if="index === 0"
        class="
          tw-relative
          tw-text-sf-gray
          tw-text-sm
          tw-leading-[1.4]
          tw-w-full
          tw-group/adjustments
        "
        data-testid="adjustments-row-label"
      >
        <span class="tw-inline-block">
          {{ I18n.t('account_entries_modal.adjustments') }}
        </span>

        <SfButtonDs
          v-if="newAdjustmentPath"
          class="
            !tw-hidden !tw-absolute
            tw-top-[50%] tw--translate-y-1/2 tw-right-0
            group-hover/adjustments:!tw-inline-flex
          "
          variant="secondary"
          size="sm"
          @click="handleNewAdjustmentClick"
        >
          {{ I18n.t('adjustment.title_new') }}
        </SfButtonDs>
      </div>
      <AmountCell
        v-else
        :amount="adjustmentsValue"
        :url="showAdjustmentsLink ? urlWithHash : null"
      />
    </template>
  </SfTableRowCollapsibleItem>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import AmountCell from './amount-cell.vue'
import { SfButtonDs } from '@silverfin/ui-components'
import { tableVariants } from '@app/shared/vue/components/sf-table/constants'
import SfTableRowCollapsibleItem from '@app/shared/vue/components/sf-table/sf-table-row-collapsible-item.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { openNewAdjustmentModal } from './utils/open-new-adjustment-modal'

interface Props {
  adjustmentsValue: string
  newAdjustmentPath?: string
  group: string
  url: string | null
}

const { adjustmentsValue, newAdjustmentPath, group, url } = defineProps<Props>()

const I18n = useI18n()

const emit =
  defineEmits<{
    'clicked-new-adjustment': []
  }>()

const urlWithHash = computed(() => {
  if (!url) {
    return null
  }
  return `${url}#show_adjustments`
})

const showAdjustmentsLink = computed(() => {
  return Number(adjustmentsValue) !== 0
})

const ignoredColumns = [
  'accountId',
  'id',
  'group',
  'groupBy',
  'accountOriginalNumberWithOriginalName',
  'newAdjustmentPath',
  'subsidiaryName',
  'subsidiaryAccountEntries',
  'adjustmentsValue',
]

const rowData = computed(() => ({
  id: `adjustments-${group}`,
  groupBy: group,
  adjustmentsValue,
  newAdjustmentPath,
  accountNumberWithName: '',
  value: adjustmentsValue,
}))

const handleNewAdjustmentClick = () => {
  emit('clicked-new-adjustment')
  openNewAdjustmentModal(newAdjustmentPath)
}
</script>
